module.exports = __webpack_public_path__ + "components/country-flag/static/vi-b70c658956c0c04f28cd9ef8ee063919.svg";